<template>
  <div>
    <h1>Profile MFA page</h1>
  </div>
</template>

<script>
export default {
  name: "ProfileMFA",
}
</script>
